import * as React from 'react';
import { alpha, styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ColorModeIconDropdown from '../../shared-theme/ColorModeIconDropdown';
import Sitemark from './SitemarkIcon';
import { useEdc } from '../edc/EdcContext';

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexShrink: 0,
  borderRadius: `calc(${theme.shape.borderRadius}px + 8px)`,
  backdropFilter: 'blur(24px)',
  border: '1px solid',
  borderColor: (theme.vars || theme).palette.divider,
  backgroundColor: theme.vars
    ? `rgba(${theme.vars.palette.background.defaultChannel} / 0.4)`
    : alpha(theme.palette.background.default, 0.4),
  boxShadow: (theme.vars || theme).shadows[1],
  padding: '8px 12px',
}));

export default function AppAppBar({ onSelectView, onShowTileForm, onShowScoreForm }) {
  const [open, setOpen] = React.useState(false);
  const { edcMode } = useEdc();

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const claimLabel = edcMode ? "I'm Going" : 'Claim Territory';

  return (
    <AppBar
      position="fixed"
      enableColorOnDark
      sx={{
        boxShadow: 0,
        bgcolor: 'transparent',
        backgroundImage: 'none',
        mt: 'calc(var(--template-frame-height, 0px) + 28px)',
      }}
    >
      <Container maxWidth="lg">
        <StyledToolbar variant="dense" sx={{border: '5px solid #106a41'}} disableGutters>
          <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', px: 0 }}>
            <Sitemark onClick={() => onSelectView('main')} />
            <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
              {!edcMode && (
                <>
                  <Button variant="text" color="info" size="small" sx={{background: 'transparent', margin:'0 5px'}} onClick={() => onSelectView('battle-for-em')}>
                    Battle For Emerald
                  </Button>
                  <Button variant="text" color="info" size="small" sx={{background: 'transparent', margin:'0 5px'}} onClick={() => onSelectView('battle-for-muni')}>
                    Battle For Muni
                  </Button>
                </>
              )}
             {/* <Button variant="text" color="info" size="small" sx={{background: 'transparent', margin:'0 5px'}} onClick={() => onSelectView('propose')}>
                Tee Times
              </Button>
              <Button variant="text" color="info" size="small" sx={{background: 'transparent', margin:'0 5px'}} onClick={() => onSelectView('scores')}>
                Scores
              </Button>*/}
            </Box>
          </Box>
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              gap: 1,
              alignItems: 'center',
            }}
          >
            <Button color="primary" variant="contained" size="small"  onClick={onShowScoreForm}>
              {claimLabel}
            </Button>
          {/*  <Button color="primary" variant="contained" size="small" onClick={onShowTileForm}>
              Propose Time
            </Button> */}
          </Box>
          <Box sx={{ display: { xs: 'flex', md: 'none' }, gap: 1 }}>
            <IconButton aria-label="Menu button" onClick={toggleDrawer(true)}>
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="top"
              open={open}
              onClose={toggleDrawer(false)}
            >
              <Box
                sx={{
                  p: 2,
                  backgroundColor: edcMode ? 'rgb(57, 36, 47)' : 'background.default',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between'
                  }}
                >
                {edcMode ? (
                  <Box
                    component="span"
                    className="edc-title"
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 900,
                      letterSpacing: '0.14em',
                      marginLeft: '5px',
                      alignSelf: 'center',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    HEADBANGER UNION LOCAL 808
                  </Box>
                ) : (
                  <img
                    src="https://images.ctfassets.net/zw84cuagwed8/657F89iQ3YSYAekJ9wtp5p/355a986267e9a9b92e1f4005f475ac27/g-med.png"
                    alt="Battle for Muni"
                    style={{
                      maxWidth: '40px',
                      height: 'auto',
                      display: 'block',
                      marginBottom: '10px',
                      marginTop: '-7px',
                      marginLeft: '5px'
                    }}
                  />
                )}
                  <IconButton onClick={toggleDrawer(false)}>
                    <CloseRoundedIcon />
                  </IconButton>
                </Box>
                {!edcMode && (
                  <>
                    <MenuItem onClick={() => { onSelectView('battle-for-em'); setOpen(false); }}>
                      Battle For Emerald
                    </MenuItem>
                    <MenuItem onClick={() => { onSelectView('battle-for-muni'); setOpen(false); }}>
                      Battle For Muni
                    </MenuItem>
                  </>
                )}
                {/*<MenuItem onClick={() => { onSelectView('propose'); setOpen(false); }}>
                  Tee Times
                </MenuItem>
                <MenuItem onClick={() => { onSelectView('scores'); setOpen(false); }}>
                  Scores
                </MenuItem>*/}
                <Divider sx={{ my: 3 }} />
                <MenuItem disableGutters>
                <Box sx={{ width: '100%' }}>
                  <Button
                    color="primary"
                    variant="contained"
                    size="small"
                    fullWidth
                    onClick={onShowScoreForm}
                    sx={{ width: { xs: '100%', sm: 'auto' } }}
                  >
                    {claimLabel}
                  </Button>
                </Box>
              </MenuItem>

              {/* <MenuItem disableGutters>
                <Box sx={{ width: '100%' }}>
                  <Button
                    color="primary"
                    variant="contained"
                    size="small"
                    fullWidth
                    onClick={onShowTileForm}
                    sx={{ width: { xs: '100%', sm: 'auto' } }}
                  >
                    Propose Time
                  </Button>
                </Box>
              </MenuItem> */}
              </Box>
            </Drawer>
          </Box>
        </StyledToolbar>
      </Container>
    </AppBar>
  );
}
